// 材质类型
export var MaterialType;
(function (MaterialType) {
    MaterialType["unlit"] = "unlit";
    MaterialType["pbr"] = "pbr";
    // 头发材质，在 pbr 材质基础上扩展
    MaterialType["hair"] = "hair";
})(MaterialType || (MaterialType = {}));
// 混合模式
export var MaterialBlending;
(function (MaterialBlending) {
    MaterialBlending[MaterialBlending["opaque"] = 100] = "opaque";
    MaterialBlending[MaterialBlending["masked"] = 101] = "masked";
    MaterialBlending[MaterialBlending["translucent"] = 102] = "translucent";
    MaterialBlending[MaterialBlending["additive"] = 103] = "additive";
})(MaterialBlending || (MaterialBlending = {}));
